import { OrderDirection } from "@/constants/orderDirection";
import { MAX_PAGE_SIZE } from "@/lib/api/max-page-size";
import { z } from "zod";
import { ColumnIds } from "./-constants";
import type { FetchJobFunctionsParams } from "./-query/type";

export const SearchSchema = z.object({
  freeText: z.string().optional(),
  showDisabled: z.boolean().default(false),
  pageSize: z.number().default(MAX_PAGE_SIZE).optional(),
  sortColumn: z
    .enum([ColumnIds.name, ColumnIds.displayOrder, ColumnIds.code])
    .optional(),
  sortOrder: z
    .nativeEnum(OrderDirection)
    .default(OrderDirection.ASC)
    .optional(),
}) satisfies z.ZodType<FetchJobFunctionsParams>;
